<template>
  <b-overlay :show="deleting">
    <template #overlay>
      <div class="text-center">
        <b-icon-x-square-fill
          font-scale="3"
          animation="throb"
          :variant="variant"
        ></b-icon-x-square-fill>
        <p>{{ btntext }}ing...</p>
      </div>
    </template>

    <b-modal
      :id="'modal-remove_' + sn"
      centered
      title="Confirm remove"
      ok
      ok-variant="success"
      cancel-variant="danger"
      @ok="topicDelete()"
    >
      <template v-slot:modal-ok> Yes, Delete </template>
      <p>Are you sure you want to delete this Topic?</p>
    </b-modal>

    <router-link
      class="event-link"
      :to="{ name: 'edittopics', params: { trackid: topic.track_id } }"
    >
      <div class="event-card -shadow p-2 m-2">
        <span class="eyebrow">Institution : {{ topic.institution }}</span>
        <div class="text-right">
          <b-button
            class="w-50"
            :variant="variant"
            @click.prevent="comfirmRemove()"
            >{{ btntext }}</b-button
          >
        </div>
        <b-badge
          v-if="topic.is_deleted == 'Yes'"
          class="topright"
          variant="danger"
          >Deleted!</b-badge
        >
        <h5 class="title mt-1">Topic for : {{ topic.topic_for }}</h5>
        <b-row>
          <b-col cols="12">
            <div>
              <h6>
                Topic Reference: <i>{{ topic.topic }}</i>
              </h6>
            </div>
          </b-col>
        </b-row>
      </div>
    </router-link>
  </b-overlay>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["topic", "sn"],
  data() {
    return {
      deleting: false
    };
  },
  created() {},
  methods: {
    ...mapActions("admin", ["fetchForTopics", "perfTopicDelete"]),
    comfirmRemove() {
      this.$bvModal.show(`modal-remove_${this.sn}`);
    },
    topicDelete() {
      this.deleting = true;
      let action = "";
      if (this.topic.is_deleted == "yes") {
        action = "Undelete";
      } else {
        action = "Delete";
      }
      let delobj = {
        action,
        trackid: this.topic.track_id
      };
      //console.log(delobj);
      return this.perfTopicDelete(delobj).then(() => {
        this.$emit("refetch");
        //this.fetchForQuestions();
        this.deleting = false;
        //console.log(response.data);
      });
    }
  },
  computed: {
    variant() {
      if (this.topic.is_deleted == "yes") {
        return "info";
      } else {
        return "danger";
      }
    },
    btntext() {
      if (this.topic.is_deleted == "yes") {
        return "Undelete";
      } else {
        return "Delete";
      }
    }
  }
};
</script>

<style scoped>
.icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.event-card {
  transition: all 0.2s linear;
  cursor: pointer;
  background-color: lightgray;
  border-radius: 10px 10px;
}

.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}

.event-link {
  color: black;
  text-decoration: none;
}

@media screen and (max-width: 768px) {
  .qimage {
    width: 100%;
    height: 200px;
  }
}

@media screen and (min-width: 768px) {
  .qimage {
    width: 75%;
    height: 250px;
  }
}
</style>
